import { countries, languages } from "countries-list";

// This checks if every required key (obj2 keys) exist in obj1 with the same value type. If yes, it returns true; otherwise, it returns false.
export const objComparison = (obj1, obj2) =>
    Object.keys(obj2).every(key => {
      const test1_1 = obj1.hasOwnProperty(key)
      const test1_2 = typeof obj1[key] === typeof obj2[key]
      if(!test1_1) console.log(key)
      if(!test1_2) console.log(typeof obj1[key], typeof obj2[key], key)
      return test1_1 && test1_2
    })

export const validFormats = ["Face-to-face", "Online", "Hybrid"]
export const validLevels = ["Beginner / Novice", "Intermediate", "Advanced", "Expert"]
export const validTimings = ["Fixed dates", "Available online", "On demand"]
export const validContentTypes = ["Theoretical and hands on", "Hands on", "Theoretical only"]
export const validCanLeadToCert = ["Yes (based on specific standards, recognized by national/international organizations)", "No", "Other (eg. certificate of attendance / participation)"]

export const inValidRange = (values, MaxRange) => {
      for (let i = 0; i < values.length; i++) {
            if (!(values[i] >= 1 && values[i] <= MaxRange)) {
                  return false
            }
      }
      return true
}

// small capitals are invalid
export const isValidLanguages = (langs) => {
      const languagesFullTextNames = Object.values(languages).map((lang) => lang.name)
      for (let i = 0; i < langs.length; i++) {
            if (!languagesFullTextNames.includes(langs[i])) {
                  return false
            }
      }
      return true
}

// small capitals are invalid
export const isValidCountryName = (country) => {
      const countryNames = Object.values(countries).map(country => country.name)
      const trimmedCountry = country.trim()
      return countryNames.includes(trimmedCountry)
}